import type { Resource } from "@ferrivia/i18n";
import fi from "./locales/fi.json";
import en from "./locales/en.json";
import enUs from "./locales/en.us.json";

export const questionnaireUiResources: Resource = {
  fi: { questionnaire: fi },
  en: { questionnaire: en },
};

export const questionnaireUiUsOverlay: Resource = {
  en: { questionnaire: enUs },
};
